import { useCallback, useEffect, useState } from 'react'

export const useAutoScroll = (emblaApi) => {
  const [autoScrollIsPlaying, setAutoScrollIsPlaying] = useState(false)

  const toggleAutoScroll = useCallback(() => {
    if (!emblaApi) return

    const autoScroll = emblaApi.plugins().autoScroll

    if (!autoScroll) return

    if (autoScroll.isPlaying()) {
      autoScroll.stop()
      setAutoScrollIsPlaying(false)
    } else {
      autoScroll.play()
      setAutoScrollIsPlaying(true)
    }
  }, [emblaApi])

  const onAutoScrollButtonClick = useCallback(
    (callback) => {
      if (!emblaApi) return

      const autoScroll = emblaApi.plugins().autoScroll

      if (autoScroll) {
        autoScroll.stop()
        setAutoScrollIsPlaying(false)
      }

      callback()
    },
    [emblaApi]
  )

  useEffect(() => {
    if (!emblaApi) return

    const autoScroll = emblaApi.plugins().autoScroll

    if (!autoScroll) return

    setAutoScrollIsPlaying(autoScroll.isPlaying())

    emblaApi
      .on('autoScroll:play', () => setAutoScrollIsPlaying(true))
      .on('autoScroll:stop', () => setAutoScrollIsPlaying(false))
  }, [emblaApi])

  return {
    autoScrollIsPlaying,
    toggleAutoScroll,
    onAutoScrollButtonClick
  }
}